import { render, staticRenderFns } from "./Judging.vue?vue&type=template&id=09e4d677&scoped=true&"
import script from "./Judging.vue?vue&type=script&lang=js&"
export * from "./Judging.vue?vue&type=script&lang=js&"
import style0 from "./Judging.vue?vue&type=style&index=0&id=09e4d677&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e4d677",
  null
  
)

export default component.exports